import { Component, Input, OnInit, Inject } from '@angular/core';
import GuestConfirmationStatusTagView from './guest-confirmation-status-tag.component.html';
import { TranslateService, _ } from '@ngx-translate/core';


@Component({
  selector: 'guest-confirmation-status-tag',
  template: GuestConfirmationStatusTagView,
  styles: [`.guest-confirmation-status-tag {
     padding: 2px 7px;
     margin-right: 5px;
    }`]
})
export class GuestConfirmationStatusTagComponent implements OnInit {
  @Input() status: string;
  @Input() answerDate?: Date | null;
  tooltipText: string = '';

  constructor(@Inject(TranslateService) private translate: TranslateService) { }

  ngOnInit() {
    this.tooltipText =  this.translate.instant(_('events.guests.' + this.status));
    if (this.answerDate) {
      this.tooltipText += ': ' + new Date(this.answerDate).toLocaleString('es');
    }
  }

  getTagStyle(): object {
    const style: Record<string, string> = { 'margin-right': '5px' };
    if (this.status === 'pending_approval') {
      style['background-color'] = '#c4a84d';
    }
    return style;
  }
}